import React from "react";
import {
  DataTableBody,
  DataTableHead,
  DataTableRow,
} from "../Component";
import UsersPageTableBodyItems from "./UsersPageTableBodyItems";

const UsersPageTableBody = ({ users }) => {
  return (
    <DataTableBody compact>
      <DataTableHead>
        <DataTableRow text="Name" />
        <DataTableRow text="Email" />
        <DataTableRow text="Registered Date" />
        <DataTableRow text="Roles" />
      </DataTableHead>
      {users?.map((item) => (
        <UsersPageTableBodyItems key={item?.id} item={item} />
      ))}
    </DataTableBody>
  );
};

export default UsersPageTableBody;
